import _get from "lodash.get";
import _merge from "lodash.merge";
import appConfig from "./app.config";

let config = null;

const globalConfig = {
  ecolixReceptionBetaEnabled: false,
  clientPortal: {
    appointmentType: {
      clientPortal: "CLIENT_PORTAL",
      store: "STORE",
    },
  },
  underConstructionRoutes: [
    "/settings/planning-changes",
    "/logs/sms",
    "/logs/wavesoft",
    "/account",
  ],
  sentryUrlKey: "https://c5611bfe2c8144c6b388cca600dc6ffa@sentry.io/1490759",
  apolloUri: "/graphql",
  pageLimit: {
    default: 20,
    noLimit: -1,
  },
  apollo: {
    httpCodeExeptionPath: "graphQLErrors.0.extensions.response.status",
  },
  orderContentAdminRole: "admin",
  user: {
    profiles: {
      super_admin: "Super Admin",
      admin: "Admin",
      contractor: "Donneur d'ordre",
      user: "Collaborateur",
      manager: "Manager",
      subcontractor: "Sous-traitant",
    },
    civilities: {
      M: "M",
      Mme: "Mme",
      Mlle: "Mlle",
    },
    jobTitles: {
      aucun: "Aucun",
      caisse: "Caisse",
      depot: "Dépôt",
      sav: "SAV",
      direction: "Direction",
      chef_de_rayon_meuble: "Chef de rayon meuble",
      chef_de_rayon_menager: "Chef de rayon ménager",
      responsable_administratif: "Responsable Administratif",
      other: "Autre",
    },
  },
  halfDays: {
    morning: "Matin",
    afternoon: "Après-midi",
  },
  days: {
    monday: "Lundi",
    tuesday: "Mardi",
    wednesday: "Mercredi",
    thursday: "Jeudi",
    friday: "Vendredi",
    saturday: "Samedi",
    sunday: "Dimanche",
  },
  office: {
    defaultNextDayShiftHour: "12:00:00",
    defaultAfternoonStartHour: "13:00:00",
    defaultExceptionalAreaStart: "09:00:00",
    defaultExceptionalAreaEnd: "17:00:00",
  },
  areas: {
    schedules: {
      defaultStartTime: "09:00:00",
      defaultEndTime: "17:00:00",
    },
  },
  dataTable: {
    highlightRowLabels: {
      forcing: "Forçage",
    },
  },
  multiselect: {
    messages: {
      default: {
        searchPlaceholder: "Rechercher...",
        selectAllMessage: "Tout sélectionner",
        clearAllMessage: "Tout déselectionner",
        noneSelectedMessage: "Aucune sélection",
        selectedMessage: "sélectionné(s)",
      },
      custom: {
        singularSelectedMessage: "sélectionné",
        pluralSelectedMessage: "sélectionnés",
      },
    },
  },
  regex: {
    frenchPhoneNumber: /^(?:(?:\+|00)33|0)\s*[1-9](?:[\s.-]*\d{2}){4}$/,
  },
  notifDefaultDuration: 4000,
  dateFormat: {
    input: "yyyy-MM-dd'T'HH:mm:ssXXX",
    output: "yyyy-MM-dd",
  },
  defaultArticleListId: "f7c37732-448f-4e7e-a716-15be7ea88d5b",
  maxArticlesInPopper: 10,
  orderStatus: {
    all: { code: "ALL", label: "Toutes" },
    validated: { code: "VALIDATED", label: "Validée" },
    pending: { code: "PENDING", label: "À traiter transporteur" },
    contractor: { code: "WAITING_FOR_CONTRACTOR", label: "À traiter magasin" },
    categorize: {
      code: "WAITING_FOR_CATEGORIZE",
      label: "Article à catégoriser",
    },
    manager: { code: "WAITING_FOR_MANAGER", label: "À traiter manager" },
    review: { code: "TO_REVIEW", label: "À relancer / message" },
    customer: {
      code: "WAITING_FOR_CUSTOMER",
      label: "À traiter client",
    },
    reception: {
      code: "WAITING_FOR_RECEPTION",
      label: "Attendue au dépôt",
    },
    cancellation: {
      code: "WAITING_CANCELLATION",
      label: "Demande d'annulation",
    },
    refund: {
      code: "WAITING_REFUND",
      label: "Demande de remboursement",
    },
    cancelled: { code: "CANCELLED", label: "Annulée" },
  },
  billingStatus: {
    all: { code: "ALL", label: "Toutes" },
    synced: { code: "SYNCED", label: "Synchronisé" },
    notsynced: { code: "NOTSYNCED", label: "Non synchronisé" },
  },
  delivery: {
    greetings: 5,
    journey_time: 10,
  },
  googleMap: {
    api: "AIzaSyCPQ-mWkw-QJAiIsfx23XnY-5-uWhw3vsE",
    colors: [
      // === Groupe 1: Couleurs primaires très distinctes (10 couleurs) ===
      "#E53935", // rouge vif (Material Red 600)
      "#1E88E5", // bleu vif (Material Blue 600)
      "#43A047", // vert vif (Material Green 600)
      "#FB8C00", // orange vif (Material Orange 600)
      "#8E24AA", // violet vif (Material Purple 600)
      "#00ACC1", // cyan foncé (Material Cyan 600)
      "#D81B60", // rose magenta (Material Pink 600)
      "#FFB300", // ambre/jaune doré (Material Amber 600)
      "#5E35B1", // violet profond (Material Deep Purple 600)
      "#00897B", // sarcelle (Material Teal 600)

      // === Groupe 2: Couleurs secondaires distinctes (10 couleurs) ===
      "#F4511E", // orange profond (Material Deep Orange 600)
      "#3949AB", // indigo vif (Material Indigo 600)
      "#7CB342", // vert lime (Material Light Green 600)
      "#C2185B", // rose foncé (Material Pink 700)
      "#039BE5", // bleu ciel vif (Material Light Blue 600)
      "#6D4C41", // marron (Material Brown 600)
      "#546E7A", // bleu gris (Material Blue Grey 600)
      "#00695C", // sarcelle foncé (Material Teal 800)
      "#AD1457", // rose profond (Material Pink 800)
      "#1565C0", // bleu foncé (Material Blue 800)

      // === Groupe 3: Couleurs tertiaires (10 couleurs) ===
      "#2E7D32", // vert foncé (Material Green 800)
      "#EF6C00", // orange foncé (Material Orange 800)
      "#6A1B9A", // violet foncé (Material Purple 800)
      "#00838F", // cyan foncé (Material Cyan 800)
      "#C62828", // rouge foncé (Material Red 800)
      "#283593", // indigo foncé (Material Indigo 800)
      "#558B2F", // vert olive clair (Material Light Green 800)
      "#4527A0", // violet profond foncé (Material Deep Purple 800)
      "#D84315", // orange brûlé (Material Deep Orange 800)
      "#00796B", // sarcelle moyen (Material Teal 700)

      // === Groupe 4: Couleurs très saturées - niveau 900 (10 couleurs) ===
      "#B71C1C", // rouge bordeaux (Material Red 900)
      "#0D47A1", // bleu marine vif (Material Blue 900)
      "#1B5E20", // vert sapin (Material Green 900)
      "#E65100", // orange intense (Material Orange 900)
      "#4A148C", // violet très foncé (Material Purple 900)
      "#006064", // cyan très foncé (Material Cyan 900)
      "#880E4F", // rose bordeaux (Material Pink 900)
      "#FF6F00", // ambre foncé (Material Amber 900)
      "#311B92", // indigo très foncé (Material Deep Purple 900)
      "#004D40", // sarcelle très foncé (Material Teal 900)

      // === Groupe 5: Couleurs moyennes - niveau 500 (10 couleurs) ===
      "#F44336", // rouge (Material Red 500)
      "#2196F3", // bleu (Material Blue 500)
      "#4CAF50", // vert (Material Green 500)
      "#FF9800", // orange (Material Orange 500)
      "#9C27B0", // violet (Material Purple 500)
      "#00BCD4", // cyan (Material Cyan 500)
      "#E91E63", // rose (Material Pink 500)
      "#FFC107", // ambre (Material Amber 500)
      "#673AB7", // violet profond (Material Deep Purple 500)
      "#009688", // sarcelle (Material Teal 500)

      // === Groupe 6: Couleurs claires - niveau 400 (10 couleurs) ===
      "#EF5350", // rouge clair (Material Red 400)
      "#42A5F5", // bleu clair (Material Blue 400)
      "#66BB6A", // vert clair (Material Green 400)
      "#FFA726", // orange clair (Material Orange 400)
      "#AB47BC", // violet clair (Material Purple 400)
      "#26C6DA", // cyan clair (Material Cyan 400)
      "#EC407A", // rose clair (Material Pink 400)
      "#FFCA28", // ambre clair (Material Amber 400)
      "#7E57C2", // violet profond clair (Material Deep Purple 400)
      "#26A69A", // sarcelle clair (Material Teal 400)

      // === Groupe 7: Couleurs additionnelles distinctes (10 couleurs) ===
      "#FF5722", // orange profond (Material Deep Orange 500)
      "#3F51B5", // indigo (Material Indigo 500)
      "#8BC34A", // vert lime (Material Light Green 500)
      "#03A9F4", // bleu ciel (Material Light Blue 500)
      "#795548", // marron (Material Brown 500)
      "#607D8B", // bleu gris (Material Blue Grey 500)
      "#CDDC39", // lime (Material Lime 500)
      "#9E9E9E", // gris (Material Grey 500)
      "#FF7043", // orange profond clair (Material Deep Orange 400)
      "#5C6BC0", // indigo clair (Material Indigo 400)

      // === Groupe 8: Nuances supplémentaires (10 couleurs) ===
      "#8D6E63", // marron clair (Material Brown 400)
      "#78909C", // bleu gris clair (Material Blue Grey 400)
      "#AED581", // vert lime clair (Material Light Green 300)
      "#4FC3F7", // bleu ciel clair (Material Light Blue 300)
      "#DCE775", // lime clair (Material Lime 300)
      "#A1887F", // marron très clair (Material Brown 300)
      "#90A4AE", // bleu gris très clair (Material Blue Grey 300)
      "#BA68C8", // violet clair (Material Purple 300)
      "#4DD0E1", // cyan clair (Material Cyan 300)
      "#81C784", // vert clair (Material Green 300)
    ],
  },
  pdfTypes: {
    confirmation: {
      endpoint: "orders/pdfOrderConfirmations/",
      filename: "confirmations-commandes.pdf",
    },
    short: {
      endpoint: "orders/pdfShort/",
      filename: "pdf-succinct.pdf",
    },
    brands: {
      endpoint: "orders/pdfBrands/",
      filename: "pdf-enseigne.pdf",
    },
    detailed: {
      endpoint: "orders/pdfDetailed/",
      filename: "pdf-detail.pdf",
    },
    preparation: {
      endpoint: "orders/pdfPreparation/",
      filename: "bordereau-preparation.pdf",
    },
    kpi: {
      endpoint: "orders/kpi/",
      filename: "export_but_kpi.xlsx",
    },
    deliveryStats: {
      endpoint: "xlsx/rounds/xlsxDeliveryStats.xlsx",
      filename: "delivery_stats.xlsx",
    },
  },
  billingConforamaEnabled: true,
  isWavesoftEnabled: false,
  isUrbantzEnabled: true,
  isRatingSystemEnabled: true,
  useMapPage: true,
  useGpsTracking: false,
  picking: {
    status: {
      PICKUP_SUCCESSFUL: {
        value: "PICKUP_SUCCESSFUL",
        label: "Prélèvement réussi",
      },
      PICKUP_OK: {
        value: "PICKUP_OK",
        label: "Prélèvement réussi",
      },
      PICKUP_FAILED: { value: "PICKUP_FAILED", label: "Prélèvement échoué" },
      PICKUP_PARTIALLY: {
        value: "PICKUP_PARTIALLY",
        label: "Prélèvement partiel",
      },
    },
    incidents: {
      DAMAGED_PACKAGING_OR_PRODUCT: {
        value: "DAMAGED_PACKAGING_OR_PRODUCT",
        label: "Emballage/produit abîmé",
      },
      MISSING_PRODUCT: { value: "MISSING_PRODUCT", label: "Produit manquant" },
      PRODUCT_OR_EAN_DOES_NOT_MATCH: {
        value: "PRODUCT_OR_EAN_DOES_NOT_MATCH",
        label: "Produit/EAN ne correspond pas",
      },
      FORCED: { value: "FORCED", label: "Forcé" },
      EXHIBITION_PRODUCT: {
        value: "EXHIBITION_PRODUCT",
        label: "Produit d'exposition",
      },
      ARTICLE_NOT_AVAILABLE: {
        value: "ARTICLE_NOT_AVAILABLE",
        label: "Article non disponible",
      },
      WRONG_QUANTITY: {
        value: "WRONG_QUANTITY",
        label: "Quantité incorrecte",
      },
    },
    // Translation mapping for picking failure reasons (including custom/test reasons)
    failureReasonTranslations: {
      // Standard incident codes
      DAMAGED_PACKAGING_OR_PRODUCT: "Emballage/produit abîmé",
      MISSING_PRODUCT: "Produit manquant",
      PRODUCT_OR_EAN_DOES_NOT_MATCH: "Produit/EAN ne correspond pas",
      FORCED: "Forcé",
      EXHIBITION_PRODUCT: "Produit d'exposition",
      ARTICLE_NOT_AVAILABLE: "Article non disponible",
      WRONG_QUANTITY: "Quantité incorrecte",

      // Common failure reasons from other parts of the system
      absent: "Client absent",
      customerCancellation: "Annulation client",
      addressNotFound: "Adresse non trouvée",
      wrongAddress: "Adresse incorrecte",
      breakdown: "Panne véhicule",
      unknown: "Personne inconnue",
      strike: "Impossible : grève",
      weather: "Impossible : conditions météo",
      damaged: "Produit abimé",
      refused: "Produit refusé par le client",
      partialDelivery: "Colis manquant",
      missingInfo: "Information ou document manquant",
      notready: "Produit non prêt (enlèvement)",
      other: "Autre",
    },
  },
  deliveryFailureReasons: {
    none: "Aucune",
    absent: "Client absent",
    customerCancellation: "Annulation client",
    addressNotFound: "Adresse non trouvée",
    wrongAddress: "Adresse incorrecte",
    breakdown: "Panne véhicule",
    unknown: "Personne inconnue",
    strike: "Impossible : grève",
    weather: "Impossible : conditions météo",
    damaged: "Produit abimé",
    refused: "Produit refusé par le client",
    partialDelivery: "Colis manquant",
    missingInfo: "Information ou document manquant",
    notready: "Produit non prêt (enlèvement)",
    closed: "Impossible de livrer dans la pièce de destination",
    other: "Autre",
    customerRequest: "Produit non repris à la demande du client",
    noProductToPickup: "Il n'y a plus de produit à reprendre",
    notUninstalled: "Le produit n'est pas désinstallé",
    badHygiene: "Mauvais état hygiénique",
    dismantledProduct: "Appareil / produit désossé",
  },
  // Specific translations for takeover/reprise article failure reasons
  articleFailureReasons: {
    customerRequest: "Demande du client",
    noProductToPickup: "Pas de produit à reprendre",
    notUninstalled: "Produit non désinstallé",
    badHygiene: "Mauvais état hygiénique",
    dismantledProduct: "Produit désossé",
    other: "Autre",
  },
  version: "2.28.0",
};

function initConfig() {
  return (config = _merge({}, globalConfig, appConfig));
}

initConfig();

export default {
  get: (key) => config && _get(config, key),
  reset: initConfig,
};
